import { useState } from 'react';
import BasicMenu from '../../Workbench/components/BasicMenu';
import { isValidDate } from '../../../utils/functions';
import { useCategory } from '../../../CategoryContext';

const getReadableTextColor = (hex) => {
  if (!hex || typeof hex !== 'string') return 'white';
  const value = hex.replace('#', '');
  if (value.length !== 6) return 'white';
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? 'black' : 'white';
};

const Note = ({
  id,
  title,
  details,
  isCompleted,
  deleteHandler,
  toggleHandler,
  editHandler,
  associatedVerticalId,
  tagColor,
  isVertical,
  assignedBy,
  createdAt,
  copyToPersonalHandler,
  canManage = true,
}) => {
  const { verticals } = useCategory();
  const associatedVertical = associatedVerticalId
    ? (verticals || []).find((v) => v.id === associatedVerticalId)
    : null;
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="note-item">
      <div className="note-header">
        <div style={{ display: 'flex', gap: '5px', alignContent: 'center' }}>
          <input
            type="checkbox"
            className="note-radio"
            onClick={(e) => {
              e.stopPropagation();
              if (!canManage) return;
              toggleHandler();
            }}
            checked={isCompleted}
            readOnly={!canManage}
            disabled={!canManage}
          />
          <p
            style={{
              marginBottom: 0,
              marginTop: 3,
              padding: 0,
              fontSize: '16px',
              color: 'black',
              textDecoration: isCompleted ? 'line-through' : 'none',
            }}
          >
            {title}
          </p>
        </div>

        {canManage && (
          <div onClick={(e) => e.stopPropagation()}>
            <BasicMenu
              deleteHandler={deleteHandler}
              editHandler={editHandler}
              copyToPersonalHandler={copyToPersonalHandler}
            />
          </div>
        )}
      </div>

      <div className="task-footer">
        {associatedVertical && (
          <button
            className="task-date"
            style={{
              backgroundColor: tagColor || '#356AC3',
              color: getReadableTextColor(tagColor || '#356AC3'),
            }}
          >
            Vertical: {associatedVertical.name}
          </button>
        )}

        {isVertical && (assignedBy || createdAt) && (
          <span
            style={{
              marginLeft: associatedVertical ? '12px' : 0,
              fontSize: '13px',
              color: '#475467',
              display: 'inline-flex',
              gap: '16px',
              alignItems: 'center',
            }}
          >
            {assignedBy && (
              <span>
                <span style={{ fontWeight: 600 }}>Written By:</span> {assignedBy}
              </span>
            )}
            {createdAt && isValidDate(new Date(createdAt)) && (
              <span>
                <span style={{ fontWeight: 600 }}>Added On:</span>{' '}
                {new Date(createdAt).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                })}
              </span>
            )}
          </span>
        )}

        {details && (
          <p
            className="note-link"
            style={{
              textAlign: 'left',
              textWrap: 'wrap',
              flexGrow: 1,
              marginTop: 10,
            }}
          >
            <span
              style={{
                textDecoration: isCompleted ? 'line-through' : 'none',
                whiteSpace: 'pre-wrap',
              }}
            >
              {expanded ? details : details.length > 280 ? `${details.slice(0, 280)}...` : details}
            </span>

            {details.length > 280 && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded(!expanded);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'blue',
                  cursor: 'pointer',
                  padding: '5px 0',
                  marginLeft: '5px',
                  display: 'inline',
                  fontSize: '14px',
                }}
                onMouseEnter={(e) => (e.target.style.color = 'darkblue')}
                onMouseLeave={(e) => (e.target.style.color = 'blue')}
              >
                {expanded ? 'Collapse' : 'Expand'}
              </span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default Note;
